/**
 * 本地时区日期工具函数
 * 避免使用 toISOString() 导致的 UTC 时区偏移问题
 * 
 * 重要：对于温哥华高尔夫球场系统，应使用Pacific时区 (America/Vancouver)
 */

/**
 * 获取本地时区的 YYYY-MM-DD 格式日期字符串
 * @param date 日期对象，默认为当前日期
 * @returns 格式为 "YYYY-MM-DD" 的字符串
 */
export function getLocalYYYYMMDD(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * 获取明天的本地日期字符串
 * @returns 格式为 "YYYY-MM-DD" 的字符串
 */
export function getTomorrowLocalYYYYMMDD(): string {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return getLocalYYYYMMDD(tomorrow);
}

/**
 * 检查给定日期字符串是否为今天
 * @param dateString 格式为 "YYYY-MM-DD" 的日期字符串
 * @returns 是否为今天
 */
export function isToday(dateString: string): boolean {
  return dateString === getLocalYYYYMMDD();
}

/**
 * 获取温哥华时区的当前时间 (Pacific Time)
 * 用于判断球场的当前时间，而不是用户所在地的时间
 * @returns 温哥华时区的Date对象
 */
export function getVancouverTime(): Date {
  const now = new Date();
  return new Date(now.toLocaleString("en-US", { timeZone: "America/Vancouver" }));
}